import '../../util/polyfill.js';

const NODE_NAME_ATTRIBUTE = 'data-node-name';

class MkComponent {
	/**
	 * @param {HTMLElement} node - root node to attach the element instance to
	 * @param {Object} [options] - options for the component
	 */
	constructor (node, options) {
		if (!node) {
			if (this.constructor._templateNode) {
				node = this.constructor._templateNode.cloneNode(true);
				node.removeAttribute('id');
			}
			else {
				return;
			}
		}

		if (!this.constructor._templateNode) {
			this.constructor._templateNode = node;
		}

		this._setNodeReferences(node);
		this.setDefaults();

		if (options) {
			Object.assign(this, options);
		}

		this.init();
		this.registerEventHandlers();
	}

	/**
	 * Query node tree for named nodes and set references
	 * @protected
	 * @param {HTMLElement} node - root node to attach the element instance to
	 */
	_setNodeReferences (node) {
		this.node = node;

		const nodes = node.querySelectorAll(`[${NODE_NAME_ATTRIBUTE}]`);
		for (let i = 0; i < nodes.length; i++) {
			const currentNode = nodes[i];
			const nodeName = currentNode.getAttribute(NODE_NAME_ATTRIBUTE);
			this[nodeName] = currentNode;
		}
	}

	/**
	 * 0th Lifecycle method: set default instance property values
	 * @abstract
	 */
	setDefaults () {}

	/**
	 * 1st Lifecycle method: initialize state and DOM
	 * @abstract
	 */
	init () {}

	/**
	 * 2nd Lifecycle method: register event handlers
	 * @abstract
	 */
	registerEventHandlers () {}

	/**
	 * Emit a DOM event from the component's node
	 * @param {string} eventName Name of event
	 * @param {Object} [eventData] Data to include in `event.detail`
	 * @param {Object} [options] Event options
	 * @returns {boolean} true if the event was canceled, otherwise false
	 */
	emit (eventName, eventData, options) {
		const eventOptions = Object.assign({ detail: eventData }, options);
		const event = new CustomEvent(eventName, eventOptions);

		return this.node.dispatchEvent(event);
	}
}

export { MkComponent };



// WEBPACK FOOTER //
// ./src/components/MkComponent/MkComponent.js